import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
// 组件批量注册
const namesv2 = [];
const listv2 = {};
const filesv2 = require.context('@/components/mapv2/listv2', true, /\.vue$/);
filesv2.keys().forEach(key => {
  let name = key.split('/').pop().replace(/\.\w+$/, '');
  if (name === 'index') return;
  namesv2.push(name);
  listv2[name] = filesv2(key).default || filesv2(key);
});
export default {
  data() {
    return {
      names: namesv2
    };
  },
  components: listv2
};